import { z } from 'zod';
/** The one stored and compared spelling of an email address in Athena. */
export function normalizeEmail(value) {
    return value.trim().toLowerCase();
}
/**
 * 254 is the longest an address can be. Normalize before validating so every
 * caller receives exactly the value PostgreSQL permits storing.
 */
export const email = z.string().transform(normalizeEmail).pipe(z.email()).pipe(z.string().max(254));
//# sourceMappingURL=email.js.map